/** App shell texts. EN is the source; ru/es must have the same keys (tsc). */
export default {
  brand: "Funded Lime",
  theme: {
    label: "Theme",
    light: "Light",
    dark: "Dark",
    system: "System",
  },
  language: "Language",
  nav: {
    home: "Home",
    menu: "Main menu",
    security: "Security",
    admin: "Admin",
    signOut: "Sign out",
  },
  home: {
    hello: "Hello, {name}",
    body: "Your challenge accounts, the terminal and the coach are here.",
    secureTitle: "Protect your account",
    secureBody: "Turn on two-step verification before you start trading.",
    secureAction: "Set up",
  },
  errors: {
    generic: "Something went wrong. Try again.",
    network: "No connection to the server.",
  },
  loading: "Loading…",
  notFound: "Page not found",
} as const;
